import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'thumbnail'})
export class ThumbnailPipe implements PipeTransform {
  transform(value: string): string {
    const thumb300 = value.replace("/images/", "/images/thumb-300w/");
    const thumb600 = value.replace("/images/", "/images/thumb-600w/");

    return `${thumb300} 600w, ${ thumb600 } 800w, ${ value } 1000w`;
  }
}